<!-- @format -->

<register-navi-modal>
  <div
    class="modal js-modal"
    is="modal-base"
    is-open="{ props.isOpen }"
    on-before-show="{ onBeforeShow }"
  >
    <div class="modal__bg js-modal-close" onclick="{ props.onClose }"></div>
    <div class="modal__content">
      <div class="modal__content_inner">
        <p class="align-c">EDITECHHUBのご登録ありがとうございます。</p>
        <p class="align-c ">
          法人様でのご利用でしょうか？個人様でのご利用でしょうか？
        </p>
        <br>
        <p class="align-c">
          該当する項目をクリックいただきご利用にあたり必要な情報登録をお願いします。
        </p>
        <br>
        <p class="align-c">法人でのご利用場合は必ず法人申請をしてください。</p>
        <p class="align-c">
          ※個人でのご利用で従業員２名以上の場合は「法人でのご利用」を選択してください。
        </p>

        <div class="container_button">
          <a
            class="button button-primary button-primary-mini"
            href="{ Routes.makePath('register-company-tag') }"
          >
            法人でのご利用
          </a>
          <a
            class="button button-primary button-primary-mini"
            href="{ Routes.makePath('register-individual-tag') }"
          >
            個人でのご利用
          </a>
        </div>
        <!--/.container_button-->
      </div>
      <!--/.modal__content_inner-->
      <a class="btn_close_modal js-modal-close" onclick="{ props.onClose }"></a>
    </div>
    <!--modal__content-->
  </div>
  <!--modal-->
  <script>
    import di from "dependency-injection";
    import base from "../modal-base.riot";
    import Routes from "@model/menu-routes.js";

    export default {
      onBeforeMount() {
        this.Routes = Routes;
      },
      components: {
        "modal-base": base,
      },
    };
  </script>
</register-navi-modal>
